<app-navbar-style-one></app-navbar-style-one>

<div id="carouselExample" class="carousel slide" data-bs-ride="carousel">
  <div class="carousel-inner">
    <div *ngFor="let offer of offers; let i = index" 
         class="carousel-item" 
         [class.active]="i === 0">
      <a class="w-100 h-100" href="/offers"><img [src]="offer.image" class="d-block w-100" [alt]="'Slide ' + (i + 1)"></a>
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>

<section class="build-your-own-section">
    <div class="container">
        <div class="row">
            <div class="col-12 text-center">
                <p class="title">Pick your size, crust, sauce, and toppings — from classic favorites to bold new flavors.</p>
            </div>
            <div class="col-12 text-center">
                <a href="custom-food" class="btn btn-primary px-5">Build Your Own</a>
            </div>
        </div>
    </div>
</section>

<section class="featured-products-section">
  <div class="carousel-container">
    <div class="carousel-wrapper">
      <div class="carousel-arrows">
        <h1 class="carousel-title">Explore product</h1>
        <div class="d-flex" style="justify-content: space-around;">
            <div class="carousel-arrow prev-arrow" (click)="prevSlide()">
                <i class="bx bx-chevron-left"></i>
            </div>
            <div class="carousel-arrow next-arrow" (click)="nextSlide()">
                <i class="bx bx-chevron-right"></i>
            </div>
        </div>
      </div>
      
      <div class="carousel-slide" *ngFor="let slide of slides; let i = index" 
           [class.active]="i === currentSlide">
        <div class="product-card" *ngFor="let product of slide" (click)="viewProduct(product)" style="cursor: pointer;">
          <div class="product-image">
            <img [src]="product.avatar" [alt]="product.name">
            <!-- Optional: Add category badge -->
            <!-- <span class="product-category-badge" *ngIf="product.categoryName">{{ product.categoryName }}</span> -->
          </div>
          <div class="product-info text-center">
            <h3 class="product-title">{{ product.name }}</h3>
            <p class="product-description" *ngIf="product.description">{{ product.description }}</p>
            
            <!-- Product type/size information -->
            <!-- <div class="product-type-info" *ngIf="getProductType(product)">
              <small class="text-muted">{{ getProductType(product) }}</small>
            </div> -->
            
            <div class="d-flex justify-content-between align-items-center">
                <span class="product-price">{{ getDisplayPrice(product) }}</span>
                <button class="add-to-cart" (click)="addToCart(product); $event.stopPropagation()">
                  <i class="bx bx-cart"></i>
                </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="lunch-menu mt-5 px-2">
    <div class="row">
        <div class="col-md-6">
            <a href="/menu/maincategory/{{lunchCategoryId[0]}}/lunch">
                <img src="{{lunchImage}}" class="img-fluid text-center animate__animated animate__backInLeft" alt="lunch">
            </a>
        </div>
        <div class="col-md-6" style="display: flex;align-content: center;align-items: center;">
            <div class="menuLunchCatering">
                <h3 class="title">Lunch</h3>
                <!-- <p class="paragraph mt-3">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p> -->
                <div class="mt-5 text-center">
                    <a href="/menu/maincategory/{{lunchCategoryId[0]}}/lunch" class="btn btn-primary px-5">Show more now</a>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="catering-menu mt-5 px-2">
    <div class="row">
        <div class="col-md-6" style="display: flex;align-content: center;align-items: center;">
            <div class="menuLunchCatering">
                <h3 class="title">Catering</h3>
                <!-- <p class="paragraph mt-3">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p> -->
                <div class="mt-5 text-center">
                    <a href="/menu/maincategory/{{cateringCategoryId[0]}}/catering" class="btn btn-primary px-5">Show more now</a>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <a href="/menu/maincategory/{{cateringCategoryId[0]}}/catering">
                <img src="{{cateringImage}}" class="img-fluid text-center animate__animated animate__backInLeft" alt="catering">
            </a>
        </div>
    </div>
</section>

<section class="mt-5 menuMenu">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-12 text-center">
                <h3>What’s on Your Plate</h3>
                <p class="mt-2 mb-4 tableServe" style="padding: 0 20%;">From appetizers to desserts, explore all the flavors we’ve prepared for you</p>
            </div>
        </div>
    </div>
   
    <div class="container-fluid px-0 mb-5">
        <div class="menu-table">
            <div class="menu-table-row" style="background-color: #CE2B37;">
                <div *ngFor="let item of menuItems" class="menu-table-cell">
                    <div class="menu-item">
                        <div class="menu-icon">
                            <a class="menuImage" routerLink="menu/subcategory/{{item.id}}/{{item.name}}">
                                <img [src]="item.avatar" [alt]="item.name" width="150" class="img-fluid">
                            </a>
                        </div>
                        <h5>
                            <a routerLink="menu/subcategory/{{item.id}}/{{item.name}}">{{item.name}}</a>
                        </h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="why-choose-us">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-7 order-md-1 order-1 d-flex justify-content-center align-items-center mb-4 mb-md-0">
                <div class="text-center">
                    <img src="assets/img/home2/cooker.png" class="cooker-image animate__animated animate__fadeInRight" alt="Cooker Image">
                </div>
            </div>
            <div class="col-lg-6 col-md-5 order-md-2 order-2">
                <div class="section-title">
                    <h2>WHY CHOOSE US</h2>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-12">
                        <div class="feature-box animate__animated animate__fadeInLeft">
                            <div class="feature-icon">
                                <img src="assets/img/home2/shrimp.png" alt="Fresh Ingredients">
                            </div>
                            <h4>Fresh Ingredients</h4>
                            <p>We source only the finest, freshest ingredients daily. From vine-ripened tomatoes to premium cheese, we ensure every slice is packed with authentic flavor.</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 mt-5">
                        <div class="feature-box animate__animated animate__fadeInLeft">
                            <div class="feature-icon">
                                <img src="assets/img/home2/apple.png" alt="Cooked to Order">
                            </div>
                            <h4>Cooked to Order</h4>
                            <p>Every pizza is hand-tossed and made from scratch the moment you order. We guarantee a piping hot, perfectly baked pie exactly the way you like it.</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <div class="feature-box animate__animated animate__fadeInLeft">
                            <div class="feature-icon">
                                <img src="assets/img/home2/time.png" alt=" Fast Delivery">
                            </div>
                            <h4>Fast Delivery</h4>
                            <p>Hot, fresh, and fast! Our dedicated delivery team works around the clock to ensure your favorite meals arrive at your doorstep right on time.</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 mt-5">
                        <div class="feature-box animate__animated animate__fadeInLeft">
                            <div class="feature-icon">
                                <img src="assets/img/home2/ok.png" alt="Top Chefs">
                            </div>
                            <h4>Top Chefs</h4>
                            <p>Our master pizza makers bring passion and decades of experience to the kitchen. We are proud to keep our original 1971 recipes and legacy alive.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-footer-style-two></app-footer-style-two>